import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const ICONS = ['🏠','🏚️','🚗','📦','🛋️','🏋️','🍷','🧸','🔧','📚'];
const FARBEN = ['#64748b','#6366f1','#f59e0b','#10b981','#ef4444','#3b82f6','#8b5cf6','#ec4899'];
const LEER_FORM = { name: '', icon: '🏠', farbe: '#64748b' };

export default function EinstellungenPage() {
  const navigate = useNavigate();
  const [standorte, setStandorte] = useState([]);
  const [form, setForm] = useState(LEER_FORM);
  const [bearbeiteId, setBearbeiteId] = useState(null);
  const [fehler, setFehler] = useState('');
  const [speichert, setSpeichert] = useState(false);
  const formRef = useRef(null);

  useEffect(() => { laden(); }, []);
  async function laden() { const r = await api.get('/standorte'); setStandorte(r.data); }

  async function speichern(e) {
    e.preventDefault();
    if (!form.name.trim()) { setFehler('Bitte gib einen Namen ein.'); return; }
    setFehler('');
    setSpeichert(true);
    try {
      if (bearbeiteId) {
        await api.put(`/standorte/${bearbeiteId}`, form);
      } else {
        await api.post('/standorte', form);
      }
      setForm(LEER_FORM);
      setBearbeiteId(null);
      laden();
    } catch {
      setFehler(bearbeiteId
        ? 'Der Standort konnte nicht gespeichert werden. Bitte versuche es erneut.'
        : 'Der Standort konnte nicht erstellt werden. Bitte versuche es erneut.');
    } finally {
      setSpeichert(false);
    }
  }

  function bearbeiten(s) {
    setForm({ name: s.name, icon: s.icon, farbe: s.farbe });
    setBearbeiteId(s.id);
    setFehler('');
    setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
  }

  function abbrechen() {
    setForm(LEER_FORM);
    setBearbeiteId(null);
    setFehler('');
  }

  async function loeschen(id, name) {
    if (!window.confirm(`Standort „${name}" wirklich löschen?\n\nKisten an diesem Standort werden keinem Standort mehr zugeordnet.`)) return;
    try {
      await api.delete(`/standorte/${id}`);
      if (bearbeiteId === id) abbrechen();
      laden();
    } catch {
      setFehler('Der Standort konnte nicht gelöscht werden. Bitte versuche es erneut.');
    }
  }

  const inp = { padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '14px' };

  return (
    <div>
      <h1 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>📍 Standorte</h1>
      <p style={{ color: '#64748b', fontSize: '13px', marginTop: '0', marginBottom: '16px' }}>Standorte helfen dir, Kisten zu gruppieren – z.B. Keller, Dachboden, Garage.</p>

      {fehler && <div role="alert" style={{ background: '#fee2e2', color: '#b91c1c', padding: '10px', borderRadius: '10px', marginBottom: '12px', fontSize: '13px' }}>{fehler}</div>}

      <div style={{ background: 'white', borderRadius: '14px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        {standorte.length === 0 && !bearbeiteId && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#94a3b8', marginBottom: '16px' }}>
            <div style={{ fontSize: '32px' }}>📍</div>
            <div style={{ marginTop: '8px', fontSize: '14px', color: '#64748b' }}>Noch keine Standorte angelegt</div>
            <div style={{ fontSize: '12px', marginTop: '4px' }}>Füge unten einen Standort hinzu.</div>
          </div>
        )}

        {standorte.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
            {standorte.map(s => (
              <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', background: bearbeiteId === s.id ? '#fefce8' : '#f8fafc', borderRadius: '10px', borderLeft: `3px solid ${s.farbe}`, border: bearbeiteId === s.id ? `2px solid #f59e0b` : undefined }}>
                <span style={{ fontSize: '20px' }}>{s.icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '600' }}>{s.name}</div>
                  <a href={`/behaelter?standort=${s.id}`} onClick={e => { e.preventDefault(); navigate(`/behaelter?standort=${s.id}`); }}
                    style={{ fontSize: '12px', color: '#6366f1', textDecoration: 'none' }}>
                    Kisten anzeigen →
                  </a>
                </div>
                <button onClick={() => bearbeiten(s)} aria-label={`Standort ${s.name} bearbeiten`} title="Standort bearbeiten"
                  style={{ background: '#eef2ff', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#6366f1', padding: '8px 10px', lineHeight: 1 }}>✏️</button>
                <button onClick={() => loeschen(s.id, s.name)} aria-label={`Standort ${s.name} löschen`} title="Standort löschen"
                  style={{ background: '#fee2e2', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#ef4444', padding: '8px 10px', lineHeight: 1 }}>🗑️</button>
              </div>
            ))}
          </div>
        )}

        <div ref={formRef} style={{ borderTop: standorte.length > 0 ? '1px solid #f1f5f9' : 'none', paddingTop: standorte.length > 0 ? '16px' : '0' }}>
          <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#374151' }}>
            {bearbeiteId ? '✏️ Standort bearbeiten' : 'Neuen Standort hinzufügen'}
          </div>
          <form onSubmit={speichern}>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', flexWrap: 'wrap' }}>
              <input style={{ ...inp, flex: 1, minWidth: '120px' }} placeholder="Name des Standorts" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required aria-label="Name des Standorts" autoFocus={!!bearbeiteId} />
            </div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '10px' }}>
              {ICONS.map(i => (
                <button key={i} type="button" onClick={() => setForm({...form, icon: i})}
                  aria-label={`Icon ${i} auswählen`}
                  style={{ fontSize: '20px', padding: '6px', border: `2px solid ${form.icon===i?'#f59e0b':'#e2e8f0'}`, borderRadius: '8px', background: 'white', cursor: 'pointer' }}>{i}</button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
              {FARBEN.map(f => (
                <button key={f} type="button" onClick={() => setForm({...form, farbe: f})}
                  aria-label={`Farbe auswählen`}
                  style={{ width: '28px', height: '28px', borderRadius: '50%', background: f, border: `3px solid ${form.farbe===f?'#1e293b':'transparent'}`, cursor: 'pointer' }} />
              ))}
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              {bearbeiteId && (
                <button type="button" onClick={abbrechen}
                  style={{ flex: 1, padding: '12px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>
                  Abbrechen
                </button>
              )}
              <button type="submit" disabled={speichert}
                style={{ flex: 2, padding: '12px', background: speichert ? '#d97706' : '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', cursor: speichert ? 'wait' : 'pointer', fontWeight: '700', opacity: speichert ? 0.85 : 1 }}>
                {speichert ? '⏳ Wird gespeichert...' : (bearbeiteId ? '💾 Änderungen speichern' : '+ Standort hinzufügen')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
